import React from 'react';
import './FeatureCard.css';

const FeatureCard = ({data, id}) => {
    const {title, description, logo, logo2} = data;
    return (
        <div className={`featureCard featureCard${id + 1}`}>
            <div>
                <div className='featureImgCard'>
                    <img src={logo2} alt="" className='featureCardImg1'/>
                    <img src={logo} alt="" className='featureCardImg2'/>
                </div>
            </div>
            <div>
                <h4>{title}</h4>
                <p>{description}.</p>
            </div>
        </div>
    );
};

export default FeatureCard;